// import api from "./axiosInstance";

// // ---------------------------------------------------------------------------
// // Recruiter-side calls (use the login cookie)
// // ---------------------------------------------------------------------------

// // ---- Tracking (list + dashboard) ----
// // TL/RECRUITER get only their own screenings; ADMIN gets all. The SERVER decides.
// // params: { page, limit, status, recommendation, search, startDate, endDate, scheduledBy, sort }
// export const listAllScreenings = (params = {}) => api.get("/screening", { params: cleanParams(params) });
// // params: { startDate, endDate, scheduledBy }
// export const getScreeningStats = (params = {}) => api.get("/screening/stats", { params: cleanParams(params) });

// // Drop empty values so the URL only carries filters that are actually set.
// function cleanParams(params) {
//   return Object.fromEntries(Object.entries(params).filter(([, v]) => v !== "" && v != null));
// }

// // ---- Per-optimization (used by ScreeningPanel / ScreeningReport) ----
// export const listScreenings = (optimizationId) => api.get(`/screening/optimization/${optimizationId}`);
// export const createScreening = (optimizationId) => api.post(`/screening/optimization/${optimizationId}`);
// export const getScreening = (id) => api.get(`/screening/${id}`);
// export const updateScreeningQuestions = (id, questions) => api.put(`/screening/${id}/questions`, { questions });
// export const sendScreening = (id, validHours = 72) => api.post(`/screening/${id}/send`, { validHours });
// export const cancelScreening = (id) => api.post(`/screening/${id}/cancel`);
// export const regenerateScreeningReport = (id) => api.post(`/screening/${id}/report`);
// export const downloadScreeningReportPdf = (id) =>
//   api.get(`/screening/${id}/report/pdf`, { responseType: "blob" });

// // ---------------------------------------------------------------------------
// // Candidate-side calls (no login — the token in the link is the key)
// // ---------------------------------------------------------------------------
// export const getPublicScreening = (token) => api.get(`/public/screening/${token}`);
// export const startPublicScreening = (token, body) => api.post(`/public/screening/${token}/start`, body);
// export const savePublicAnswer = (token, body) => api.post(`/public/screening/${token}/answer`, body);
// export const completePublicScreening = (token) => api.post(`/public/screening/${token}/complete`);

// // Pulls the backend's message out of an axios error.
// export const apiErrorMessage = (err, fallback = "Something went wrong. Try again.") =>
//   err?.response?.data?.message || fallback;

// // Long labels used on the optimization page and the report page.
// export const STATUS_LABELS = {
//   DRAFT: "Draft — review questions",
//   SENT: "Link sent",
//   IN_PROGRESS: "Candidate answering",
//   COMPLETED: "Writing report…",
//   REPORT_READY: "Report ready",
//   REPORT_FAILED: "Report failed",
//   CANCELLED: "Withdrawn",
// };

// export const VERDICT_LABELS = {
//   ADVANCE: "Advance",
//   HOLD: "Hold",
//   NOT_RECOMMENDED: "Not recommended",
// };

// // Statuses the tracker can filter by. EXPIRED and NOT_OPENED are worked out
// // by the server (they aren't stored); SENT / IN_PROGRESS mean "link still live".
// export const TRACKER_STATUS_OPTIONS = [
//   { value: "DRAFT", label: "Draft" },
//   { value: "SENT", label: "Link sent" },
//   { value: "NOT_OPENED", label: "Sent – not opened yet" },
//   { value: "IN_PROGRESS", label: "In progress" },
//   { value: "COMPLETED", label: "Generating report" },
//   { value: "REPORT_READY", label: "Report ready" },
//   { value: "REPORT_FAILED", label: "Report failed" },
//   { value: "EXPIRED", label: "Expired" },
//   { value: "CANCELLED", label: "Withdrawn" },
// ];

// // Short labels for the status badge in tracker tables.
// export const TRACKER_STATUS_LABELS = {
//   DRAFT: "Draft",
//   SENT: "Link sent",
//   IN_PROGRESS: "In progress",
//   COMPLETED: "Generating report",
//   REPORT_READY: "Report ready",
//   REPORT_FAILED: "Report failed",
//   EXPIRED: "Expired",
//   CANCELLED: "Withdrawn",
// };

import api from "./axiosInstance";

// ---------------------------------------------------------------------------
// Recruiter-side calls (use the login cookie)
// ---------------------------------------------------------------------------

// ---- Tracking (list + dashboard) ----
// TL/RECRUITER get only their own screenings; ADMIN gets all. The SERVER decides.
// params: { page, limit, status, recommendation, search, startDate, endDate, scheduledBy, sort }
export const listAllScreenings = (params = {}) => api.get("/screening", { params: cleanParams(params) });
// params: { startDate, endDate, scheduledBy }
export const getScreeningStats = (params = {}) => api.get("/screening/stats", { params: cleanParams(params) });

// Drop empty values so the URL only carries filters that are actually set.
function cleanParams(params) {
  return Object.fromEntries(Object.entries(params).filter(([, v]) => v !== "" && v != null));
}

// ---- Per-optimization (used by ScreeningPanel / ScreeningReport) ----
export const listScreenings = (optimizationId) => api.get(`/screening/optimization/${optimizationId}`);
export const createScreening = (optimizationId) => api.post(`/screening/optimization/${optimizationId}`);
export const getScreening = (id) => api.get(`/screening/${id}`);
export const updateScreeningQuestions = (id, questions) => api.put(`/screening/${id}/questions`, { questions });
export const sendScreening = (id, validHours = 72) => api.post(`/screening/${id}/send`, { validHours });
export const cancelScreening = (id) => api.post(`/screening/${id}/cancel`);
// Server emails the link from the company screening mailbox.
export const emailScreeningInvite = (id) => api.post(`/screening/${id}/email`);
export const regenerateScreeningReport = (id) => api.post(`/screening/${id}/report`);
export const downloadScreeningReportPdf = (id) =>
  api.get(`/screening/${id}/report/pdf`, { responseType: "blob" });

// ---------------------------------------------------------------------------
// Candidate-side calls (no login — the token in the link is the key)
// ---------------------------------------------------------------------------
export const getPublicScreening = (token) => api.get(`/public/screening/${token}`);
export const startPublicScreening = (token, body) => api.post(`/public/screening/${token}/start`, body);
export const savePublicAnswer = (token, body) => api.post(`/public/screening/${token}/answer`, body);
export const completePublicScreening = (token) => api.post(`/public/screening/${token}/complete`);

// Pulls the backend's message out of an axios error.
export const apiErrorMessage = (err, fallback = "Something went wrong. Try again.") =>
  err?.response?.data?.message || fallback;

// Long labels used on the optimization page and the report page.
export const STATUS_LABELS = {
  DRAFT: "Draft — review questions",
  SENT: "Link sent",
  IN_PROGRESS: "Candidate answering",
  COMPLETED: "Writing report…",
  REPORT_READY: "Report ready",
  REPORT_FAILED: "Report failed",
  CANCELLED: "Withdrawn",
};

export const VERDICT_LABELS = {
  ADVANCE: "Advance",
  HOLD: "Hold",
  NOT_RECOMMENDED: "Not recommended",
};

// Statuses the tracker can filter by. EXPIRED and NOT_OPENED are worked out
// by the server (they aren't stored); SENT / IN_PROGRESS mean "link still live".
export const TRACKER_STATUS_OPTIONS = [
  { value: "DRAFT", label: "Draft" },
  { value: "SENT", label: "Link sent" },
  { value: "NOT_OPENED", label: "Sent – not opened yet" },
  { value: "IN_PROGRESS", label: "In progress" },
  { value: "COMPLETED", label: "Generating report" },
  { value: "REPORT_READY", label: "Report ready" },
  { value: "REPORT_FAILED", label: "Report failed" },
  { value: "EXPIRED", label: "Expired" },
  { value: "CANCELLED", label: "Withdrawn" },
];

// Short labels for the status badge in tracker tables.
export const TRACKER_STATUS_LABELS = {
  DRAFT: "Draft",
  SENT: "Link sent",
  IN_PROGRESS: "In progress",
  COMPLETED: "Generating report",
  REPORT_READY: "Report ready",
  REPORT_FAILED: "Report failed",
  EXPIRED: "Expired",
  CANCELLED: "Withdrawn",
};